import { BillingExplorerXAxisOption } from "./types.";

export const billingExplorerXAxisOptions: BillingExplorerXAxisOption[] = [
  {
    value: "date",
    label: "Date",
  },
  {
    value: "account",
    label: "Account",
  },
  {
    value: "service",
    label: "Service",
  },
  {
    value: "region",
    label: "Region",
  },
  {
    value: "product_family",
    label: "Product Family",
  },
  {
    value: "charge_type",
    label: "Charge Type",
  },
  {
    value: "instance_type",
    label: "Instance Type",
  },
  {
    value: "instance_family",
    label: "Instance Family",
  },
  {
    value: "environment",
    label: "Environment",
  },
  {
    value: "marketplace_service",
    label: "Marketplace Service",
  },
];
